import {
  ThemeProvider,
  ToastContainer,
  View,
} from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import { Outlet, useHref, useNavigate } from "react-router"
import { defaultSpectrumTheme } from "@/components/wrappers/Spectrum/SpectrumConstants.ts"
import { useAppSelector } from "@/store/store.ts"

export function RootLayout() {
  const theme = useAppSelector((state) => state.uiPreferences.theme)
  const scale = useAppSelector((state) => state.uiPreferences.scale)
  const navigate = useNavigate() as () => void
  return (
    <ThemeProvider
      colorScheme={theme}
      theme={defaultSpectrumTheme}
      scale={scale}
      height="100%"
      width="100%"
      router={{ navigate, useHref }}
    >
      <View height="100%" width="100%">
        <ToastContainer placement="top" />
        <Outlet />
      </View>
    </ThemeProvider>
  )
}
